import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-attendance-complete',
    templateUrl: './attendance-complete.component.html',
    styleUrls: ['./attendance-complete.component.scss']
})
export class AttendanceCompleteComponent implements OnInit {
  @Input() meetingID: string;
  constructor() { }

  ngOnInit(): void {
  }

}
